import React, { useEffect, useState } from "react";
import axios from "../../../axios"
import CheckBoxType from "../Completed/QuestionCompleted/CheckBoxType";
import SubmisshionByUpload from "../Completed/QuestionCompleted/SubmisshionByUpload";
import VerticalProgBar from "./VarticalProgressBar/VerticalProgBar";
import AdaptiveEvalutionGraph from "../Completed/QuestionCompleted/AdaptiveEvalutionGraph";
import FailedApiPopup from "../Completed/QuestionCompleted/FailedApiPopup";
import PopupforNoQsAttempt from "../Completed/QuestionCompleted/PopupforNoQsAttempt";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import CheckboxQuestionPrevious from "./CheckboxQuestionPrevious";
import DescriptiveQuestionsPrevious from "./DescriptiveQuestionsPrevious";

function PreviousAssessment() {
    const { state } = useLocation();
    const [isGettingData, setIsGettingData] = useState(true);
    const userId = useSelector((state) => state.user?.currentUser?.id);
    const [studentMarksDetails, setStudentMarksDetails] = useState([])
    const [questionNo, setQuestionNo] = useState(0);
    const [skillsValue, setSkillsValue] = useState(0);
    const [chartData, setChartData] = useState()
    const [failedApiPopup, setFailedApiPopup] = useState(false)
    const [popupOpen, setPopupOpen] = useState(false);
    const [pendingData, setPendingData] = useState(null);

    useEffect(() => {
        getStudentResponse();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state?.assessmentId, userId]);
    const getStudentResponse = async () => {
        try {
            let res = await axios.get(
                `/assessment/getForStudent/${state?.assessmentId}`
            );
            setPendingData(res?.data?.data)

            setIsGettingData(false);
        } catch (error) {
            // toast.error("Assessment Not Found!!")
            setFailedApiPopup(true)
            setIsGettingData(false);
            console.log(error);
        }
    };

    const [allQuestion, setAllQuestion] = useState({
        sucessful: false,
    });

    useEffect(() => {
        const getStudentMarksDetails = async () => {
            try {
                const res = await axios.get(
                    `/assessment/${state.assessmentId}/studentScoreBoard/get/studentId/${userId}`
                );
                res && setStudentMarksDetails(res?.data?.data)
                setIsGettingData(false);
            } catch (error) {
                setIsGettingData(false);
                console.log("error", error)
            }
        }
        getStudentMarksDetails()
    }, [])


    const timeHelper = (a) => {
        if (!a) return null;
        const dateObj = new Date(a);
        const userOffset = dateObj.getTimezoneOffset() * 60000;
        const localDate = new Date(dateObj - userOffset);

        const day = localDate.getDate().toString().padStart(2, "0");
        const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
        const year = localDate.getFullYear();
        const outputDateString = `${day}/${month}/${year}`;
        return outputDateString;
    };
    const [difficulty, setDifficulty] = useState(0);

    const difficultyLevels = ["Very Hard", "Hard", "Medium", "Easy", "Very Easy"];
    const skillsLevels = ["Create", "Evalute", "Analyze", "Apply", "Understand", "Remember"];


    const getDifficultyName = (resultes) => {
        const questionTypeMap = {
            "Very Easy": 1,
            "Easy": 2,
            "Medium": 3,
            "Difficult": 4,
            "Very Difficult": 5,
        };
        const questionTypeMapSkill = {
            "Create": 6,
            "Evaluate": 5,
            "Analyze": 4,
            "Apply": 3,
            "Understand": 2,
            "Remember": 1,
        };
        let currectQues = [];
        for (let i = 0; i < resultes.length; i++) {
            if (questionNo === i) {
                currectQues.push(resultes[i])
            }
        }
        const difficultyValue = questionTypeMap[currectQues[0]?.question_response?.question?.difficulty_level?.name] || 0;
        const skillsValue = questionTypeMapSkill[currectQues[0]?.question_response?.question?.skill?.name] || 0;
        setDifficulty(difficultyValue);
        setSkillsValue(skillsValue);
    }

    const showSummary = {
        background: "#F77F00",
        fontSize: "16px",
        padding: "11px 14px",
        fontWeight: "600",
        borderRadius: "5px",
        border: "none",
        color: '#fff'
    }

    const handleRouteBack = () => {
        if (FromSummaryUpdate === 'FromSummaryUpdate') {
            window.history.back()
        } else {
            handleViewAnswerQuestionFalse()
        }
    }
    console.log("pendingData", pendingData);


    return <div>
        <>
            {
                isGettingData ? (
                    <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
                        <img
                            className="ongoing_internal_loader"
                            src="/gif/LoaderDot.gif"
                            alt=""
                        />
                    </div>) : (
                    <div className="ContainerQuestion d-flex p-4 gap-1">
                        <div>
                            <img
                                style={{ cursor: "pointer" }}
                                onClick={() => window.history.back()}
                                src="/HwImg/backArrow.png"
                                alt=""
                            />{" "}
                            &nbsp;
                        </div>
                        <div className="hederContainer1">
                            <div>
                                <div className="d-flex justify-content-between w-100 mb-1">
                                    <div className="d-flex">
                                        <div className="quesHeading">
                                            {pendingData?.assessment?.name}
                                        </div>
                                        <div className="penddingButton ml-2">Completed</div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between w-100 mt-2 mb-2" style={{ position: "relative" }}>
                                    <div className="d-flex">
                                        <div>
                                            <span className="subTitle2">
                                                {pendingData?.subject_id?.name}
                                            </span>
                                            &nbsp;
                                        </div>
                                        <div>
                                            <span>|</span> &nbsp;
                                            <span className="subTitles3">Created At</span> &nbsp;
                                            <span className="subTitle2">
                                                {timeHelper(pendingData?.created_at)}
                                            </span>
                                            &nbsp;
                                        </div>
                                        {
                                            state?.item?.isAdaptive && (< span style={{ padding: "7px 12px", position: "absolute", top: "-6px", left: "630px", borderRadius: "6px" }}>
                                                <img src="/images/adaptiveImg.png" alt="img" style={{ width: "120px" }} />
                                            </span>)
                                        }
                                        {
                                            state?.item?.autoEvalEnabled && (< span style={{ padding: "7px 12px", position: "absolute", top: "-26px", left: "630px", borderRadius: "6px" }}>
                                                <img src="/images/auto-eva.png" alt="img" style={{ width: "90px" }} />
                                            </span>)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div style={{ fontSize: "18px", fontWeight: "500", margin: "15px 0px" }}>{pendingData?.description}</div>
                            <div className="mt-3 d-flex gap-2" style={{ overflowX: "auto" }}>
                                {pendingData?.questions?.length > 0 &&
                                    pendingData?.questions?.map((item, index) => (
                                        <div
                                            onClick={(e) => setQuestionNo(index)}
                                            className={
                                                questionNo > index
                                                    ? "QuestionActiveNo"
                                                    : "QuestionNoNonActive"
                                            }
                                            style={{
                                                borderColor: item?.is_mandatory
                                                    ? "#AC1616"
                                                    : questionNo === index
                                                        ? "#F99933"
                                                        : questionNo > index
                                                            ? "#F77F00"
                                                            : "#668598",
                                                color:
                                                    questionNo === index
                                                        ? "#F99933"
                                                        : questionNo > index
                                                            ? "#F77F00"
                                                            : "#668598",
                                                backgroundColor:
                                                    questionNo > index ? "#FEF2E5" : "transparent",
                                                minWidth: "30px",
                                            }}
                                        >
                                            Q{index + 1}
                                        </div>
                                    ))}
                            </div>
                            <div className="mt-4 allquestionTypesContainer d-flex">
                                <div style={{ flex: pendingData?.isAdaptive ? "0 0 66%" : "0 0 100%" }}>
                                    {
                                        !pendingData?.questions?.[questionNo]?.type?.is_manually_graded ? (
                                            <CheckboxQuestionPrevious
                                                questionNo={questionNo + 1}
                                                response={pendingData?.questions[questionNo]}
                                                isAdaptiveCheck={pendingData?.isAdaptive}
                                            />
                                        ) : (
                                            <DescriptiveQuestionsPrevious
                                                questionNo={questionNo + 1}
                                                response={pendingData?.questions[questionNo]}
                                                isAdaptiveCheck={pendingData?.isAdaptive}
                                            />
                                        )}
                                </div>

                                {pendingData?.isAdaptive && (
                                    <div style={{ flex: "0 0 34%" }}>
                                        <div style={{ display: "flex", marginTop: "42px" }}>
                                            <VerticalProgBar
                                                title="Difficulty"
                                                levels={difficultyLevels}
                                                progress={difficulty * 20}
                                            />
                                            <VerticalProgBar
                                                title="Skills"
                                                levels={skillsLevels}
                                                progress={skillsValue * 16.67}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="flex h-40 justify-between overflow-scroll">
                                <div>
                                    {
                                        pendingData?.isAdaptive ? null :
                                            <>
                                                <span className="font-bold text-blue-950">Result</span>
                                                <div className="quesHeading d-flex justify-content-start">
                                                    <span className="subTitles">Question No. : </span> &nbsp;&nbsp;
                                                    {questionNo + 1}
                                                </div>
                                                <div>
                                                    <span className="subTitles">Total Marks: </span> &nbsp;&nbsp;
                                                    <span className="quesHeading">
                                                        {pendingData?.total_marks}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span className="subTitles">This Question Marks: </span>&nbsp;&nbsp;
                                                    <span className="quesHeading">
                                                        {
                                                            pendingData?.questions[questionNo]?.correct_score
                                                        }
                                                    </span>
                                                </div>
                                            </>
                                    }
                                </div>
                                <div className="nextBtnContainer">
                                    {questionNo >= 1 && (
                                        <button
                                            className="PreviousBtnQue"
                                            onClick={(e) => setQuestionNo(questionNo - 1)}
                                        >
                                            Previous
                                        </button>
                                    )}
                                    &nbsp;
                                    {pendingData?.questions?.length > questionNo + 1 && (
                                        <button
                                            className="nextBtnQue"
                                            onClick={(e) => setQuestionNo(questionNo + 1)}
                                        >
                                            Next
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* {
                            openGraphPopup && (
                                <AdaptiveEvalutionGraph
                                    studentResultData={studentResultData}
                                    chartData={chartData}
                                    studentMarksDetails={studentMarksDetails}
                                    setOpenGraphPopup={setOpenGraphPopup}
                                    assessmentisAdaptive={studentResultData?.assessment?.isAdaptive}
                                />
                            )
                        } */}
                        {failedApiPopup && (
                            <FailedApiPopup handleRouteBack={handleRouteBack} />
                        )}
                        {popupOpen &&
                            <PopupforNoQsAttempt handleRouteBack={handleRouteBack} />
                        }
                    </div>
                )
            }
        </>
    </div>;
}

export default PreviousAssessment;
